import type { ReactElement } from 'react';
import { useState } from 'react';
import { ApiError } from '@fetmode/api-client';
import { useAuth } from '@fetmode/app-core';
import { t } from '@fetmode/i18n';

import { useStudioModel } from '../../../features/studio/index.js';
import './ChatAvailabilitySelect.css';

export function ChatAvailabilitySelect(): ReactElement | null {
  const { api } = useAuth();
  const { profile, setProfile } = useStudioModel();
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleChange(next: boolean): Promise<void> {
    if (!profile) {
      return;
    }
    setIsUpdating(true);
    setError(null);
    try {
      const result = await api.updateModelAvailability({ chatAvailable: next });
      setProfile(result.profile);
    } catch (err) {
      setError(
        err instanceof ApiError ? err.message : t('common.studio.dashboard.chatAvailabilityError'),
      );
    } finally {
      setIsUpdating(false);
    }
  }

  if (!profile) {
    return null;
  }

  return (
    <label className="app-shell__chat">
      <span>{t('common.studio.nav.chat')}</span>
      <select
        className="app-shell__chat-select"
        value={profile.chatAvailable ? 'online' : 'offline'}
        disabled={isUpdating}
        aria-label={t('common.studio.nav.chat')}
        title={error ?? undefined}
        onChange={(event) => {
          void handleChange(event.target.value === 'online');
        }}
      >
        <option value="online">{t('common.studio.nav.chatOnline')}</option>
        <option value="offline">{t('common.studio.nav.chatOffline')}</option>
      </select>
    </label>
  );
}
